import { Component, HostListener, ViewChild, inject } from "@angular/core";
import { MatSidenav, MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { ModeService } from "@cq/app/core/environment/mode.service";
import { DialogService } from "@cq/app/shared/dialog/services/dialog.service";
import { Router } from "@angular/router";
import { IconModule } from "@cq/app/shared/icon/icon.module";

@Component({
  selector: "cq-tools-sidenav",
  imports: [IconModule, MatListModule, MatSidenavModule],
  templateUrl: "./tools-sidenav.component.html",
  styleUrl: "./tools-sidenav.component.scss",
})
export class ToolsSidenavComponent {
  private readonly mode = inject(ModeService);
  private readonly dialog = inject(DialogService);
  private readonly router = inject(Router);

  @ViewChild(MatSidenav) sidenav!: MatSidenav;

  private toolActive = false;

  @HostListener("window:keydown.alt.shift.t", ["$event"])
  toggle(event: KeyboardEvent | Event) {
    this.guard(() => {
      event.preventDefault();
      this.sidenav.toggle();
    });
  }

  @HostListener("window:keydown.alt.shift.u", ["$event"])
  upgrade(event?: KeyboardEvent | Event) {
    this.sidenav.close();
    this.guard(() => {
      event?.preventDefault();

      import("../page-upgrade-dialog/page-upgrade-dialog.component").then(
        (mod) => {
          this.toolActive = true;
          this.dialog
            .open(mod.PageUpgradeDialogComponent)
            .afterClosed()
            .subscribe(() => (this.toolActive = false));
        },
      );
    });
  }

  @HostListener("window:keydown.alt.shift.f", ["$event"])
  feature(event?: KeyboardEvent | Event) {
    this.sidenav.close();
    this.guard(() => {
      event?.preventDefault();

      import("../feature-flag-dialog/feature-flag-dialog.component").then(
        (mod) => {
          this.toolActive = true;
          this.dialog
            .open(mod.FeatureFlagDialogComponent)
            .afterClosed()
            .subscribe(() => (this.toolActive = false));
        },
      );
    });
  }

  @HostListener("window:keydown.alt.shift.m", ["$event"])
  mockup(event?: KeyboardEvent | Event) {
    this.sidenav.close();
    this.guard(() => {
      event?.preventDefault();
      this.toolActive = true;
      this.router
        .navigate(["upgrade/mockup"])
        .then(() => (this.toolActive = false));
    });
  }

  @HostListener("window:keydown.alt.shift.s", ["$event"])
  settings(event?: KeyboardEvent | Event) {
    this.sidenav.close();
    this.guard(() => {
      event?.preventDefault();

      import("../settings-dialog/settings-dialog.component").then((mod) => {
        this.toolActive = true;
        this.dialog
          .open(mod.SettingsDialogComponent)
          .afterClosed()
          .subscribe(() => (this.toolActive = false));
      });
    });
  }

  @HostListener("window:keydown.alt.shift.v", ["$event"])
  validation(event?: KeyboardEvent | Event) {
    this.sidenav.close();
    this.guard(() => {
      event?.preventDefault();

      import("../validation-navigation-dialog/validation-navigation-dialog.component").then(
        (mod) => {
          this.toolActive = true;
          this.dialog
            .open(mod.ValidationNavigationDialogComponent)
            .afterClosed()
            .subscribe(() => (this.toolActive = false));
        },
      );
    });
  }

  private guard(callback: () => unknown) {
    if (this.toolActive) {
      return;
    }

    this.mode.guard(callback);
  }
}
